import datetimeFormats from './locales/datetimeFormats'

// Configuration for vue-i18n specific settings that can't be set in nuxt.config.ts.
// With nuxt-i18n, some settings can be set throught the nuxt config, but not all.
export default defineI18nConfig(() => {
  return {
    fallbackLocale: ['nl', 'en'],
    datetimeFormats: datetimeFormats,
    // Silance warnings about missing translations / fallback shit
    // This was the only i was able to silce '[intlify] Not found 'time' key in 'en' locale messages.' warnings.
    missingWarn: false,
    fallbackWarn: false,
  }
})
